import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomeNavBar from "./HomeNavBar";
import { Container } from "semantic-ui-react";
import ApplicantConsole from "./console/ApplicantConsole";


function Home() {
  return (
    <Container fluid>
      <HomeNavBar />
      <Router>
        <Switch>
          <Route path="/" component={ApplicantConsole} />
        </Switch>
      </Router>
    </Container>
  );
}

export default Home;
